export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_26-2ab54ce1cfdc6dac5322373f2439626d.jpg";